import { action, observable, makeAutoObservable } from 'mobx';
import { ChangeEvent } from 'react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { TypeId } from 'src_common/common/websocket2/type';
import { EventMarketParticipantsPropsType } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketParticipantsForm/EventMarketParticipantsForm';

export class EventMarketParticipantsFormState {
    @observable filter: string = '';
    @observable current: SelectionModel[] = [];
    @observable chosen: SelectionModel[] = [];
    @observable available: SelectionModel[] = [];

    constructor(private readonly props: EventMarketParticipantsPropsType) {
        const arrayParticipants = Object.values(props.eventParticipants);
        const eventsNameSet = new Set(arrayParticipants.map((p) => p.name));
        this.current = props.marketSelections.filter((p) => {
            return eventsNameSet.has(p.name);
        });

        const currentNames = this.current.concat([]).map((p) => p.name);
        //@ts-expect-error
        this.available = arrayParticipants.filter(
            (p) => p.name !== null && p.name !== undefined && !currentNames.includes(p.name)
        );
        makeAutoObservable(this);
    }

    @action onSetFilter = (e: ChangeEvent<HTMLInputElement>): void => {
        this.filter = e.currentTarget.value.toLowerCase().trim();
    };

    @action removeParticipant = (participant: SelectionModel): void => {
        this.available.push(participant);
        this.chosen = this.chosen.filter((innerParticipant) => participant.id !== innerParticipant.id);
    };

    @action addParticipant = (participant: SelectionModel): void => {
        this.available = this.available.filter((p) => p.id !== participant.id);
        this.chosen.push(participant);
    };

    @action submitConfirm = (): void => {
        this.onSubmit('confirmSelection');
    };

    @action submitAddAll = (): void => {
        this.onSubmit('addAll');
    };

    @action onSubmit = (type: 'confirmSelection' | 'addAll'): void => {
        const { marketId } = this.props;
        const oldMarketId = TypeId.getMarketId(marketId);
        const eventId = TypeId.getEventId(marketId);
        const currentNames = this.current.map((s) => s.name);
        const chosen = this.chosen.filter((s) => !currentNames.includes(s.name));
        const available =
            this.available.length > 0
                ? this.available.filter((p) => !currentNames.includes(p.name))
                : Object.values(this.props.eventParticipants).filter(
                      (p) => p.name !== null && p.name !== undefined && !currentNames.includes(p.name)
                  );

        if (type === 'confirmSelection' && chosen.length > 0) {
            this.props.onAddAllSelections(eventId, oldMarketId, chosen);
        } else if (type === 'addAll' && available.length > 0) {
            this.props.onAddAllSelections(eventId, oldMarketId, available);
        }
        this.props.onSubmit();
    };

    filterParticipants = (participant: SelectionModel): boolean => {
        return this.filter === '' || participant.name.toLowerCase().includes(this.filter);
    };
}
